//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum PointOfInterestCategory {
	Eat = 69,
	Shop = 72,
	Sleep = 76,
	Practical = 79,
	Party = 80,
	SeeAndDo = 83
}
